function ajaxSearch(value, destination) {
	
	if(value && destination){

		var resultWrapper = document.querySelector(destination);
		var spinner = document.getElementById('search-spinner');

		if(resultWrapper){

			jQuery.ajax({
				url : postdata.ajax_url,
				type : 'post',
				data : {
					action : 'smx_search_result',
					value : value
				},
				beforeSend: function () {
					spinner.classList.add('show');
					resultWrapper.innerHTML = '';
				},
				success : function( data ) {
					spinner.classList.remove('show');
					resultWrapper.innerHTML = data;
				}
			});
		}
	}
	
}

let searchPromise = false;

function laxyAjaxSearch(value, destination) {
	if (searchPromise) {
		clearTimeout(searchPromise);
	}
	searchPromise = setTimeout(() => {
		if (value.length > 2) {
			ajaxSearch(value, destination);
		}
	}, 1000);
}

window.laxyAjaxSearch = laxyAjaxSearch;